/**
 * Add a new company
 *
 * @param company
 * @returns {function(*)}
 */
import {addNotification as notify} from 'reapop';
import l10n from "../l10n/localization";
import * as types from "../constants/actionTypes";
import * as ajaxRoutes from "../constants/ajaxRoutes";
import * as authHandler from "../utils/authHandler";
import * as filesActions from "../graphql/actions/files";
import { saveAs } from 'file-saver';

export const add = (file, fogId) => {

    return (dispatch) => {
        let url = ajaxRoutes.API_ROUTE + "/fog/files/add/" + fogId;
        console.log('//// action -file - test ////', typeof file);
        dispatch(saving());
        let headers = new Headers({"X-Authorization": 'Bearer ' + authHandler.getToken()});
        fetch(url, {headers: headers,method: 'POST',body: file})
        .then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }

            dispatch(notify({message: l10n.messages.success, status: 'success'}));
            return response;
        })
        .then(() => {
            dispatch(saved());
            dispatch(fetchFile(fogId, true));
        })
        .catch((error) => {
            dispatch(notify({message: error.message, status: 'error'}));
            dispatch(saved());
        });
    };
};

export const editFileName = (id, file, fogId, successCallback) => {
    console.log(file, id, fogId)

    return dispatch => {
        dispatch(loading());

        filesActions.edit(function() {
            dispatch(saved());
            dispatch(fetchFile(fogId, true));
            successCallback();
        }, function (error) {
            dispatch(errorSaving());
            dispatch(notify({message: error.message, status: 'error'}));
            successCallback();
        }, id, {
            name: file.name,
            fog_id: fogId,
            mimetype: file.mimetype,
            path: file.path,
            size: file.size,
        })
    }
};

export const fetchFile = (fogId, force = false) => {

    return dispatch => {
        dispatch(loading());
        filesActions.getFiles(
            function (response) {
                dispatch(receiveFiles(response.data.files));
            },
            function (error) {
                dispatch(notify({message: error.message, status: 'error'}));
            },
            fogId,
            force
        );
    };

};

export const downloadFile = (fileID, filename) => {

    let url = ajaxRoutes.API_ROUTE + "/fog/files/download/" + fileID;

    return dispatch => {
        let headers = new Headers({"X-Authorization": 'Bearer ' + authHandler.getToken()});

        fetch(url, {headers: headers})
            .then((response) => {
                return response.blob();
            })
            .then((blob) => {
                saveAs(blob, filename);
            })
            .catch((error) => {});
    };
};

export const deleteFile = (fileID,fogID) => {

    return dispatch => {
        let url = ajaxRoutes.API_ROUTE + "/fog/files/delete/" + fileID;
        let headers = new Headers({"X-Authorization": 'Bearer ' + authHandler.getToken()});

        fetch(url, {headers: headers})
        .then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            dispatch(notify({message: l10n.messages.remove, status: 'success'}));
            return response;
        })
        .then(() => {
            dispatch(doneDeletingFiles());
            dispatch(fetchFile(fogID, true));
        })
        .catch((error) => {
            dispatch(notify({message: error.message, status: 'error'}));
            dispatch(doneDeletingFiles());
        });
    };
};

export function loading() {
    return {
        type: types.LOADING_FILES
    };
}

export function doneDeletingFiles() {
    return {
        type: types.DONE_DELETING_FILES
    };
}

export function deletingFiles() {
    return {
        type: types.DELETING_FILES
    };
}

export function saving() {
    return {
        type: types.SAVING_FILES
    };
}

export function saved() {
    return {
        type: types.SAVED_FILES
    };
}

export function errorSaving() {
    return {
        type: types.ERROR_SAVING_FILES,
    };
}

export function receiveFiles(data) {
    return {
        type: types.RECEIVED_FILES,
        payload: data
    };
}

export function errorMessage(message) {
    return dispatch => {
        dispatch(notify({message: message, status: 'error',dismissAfter: 8000}));
    };
}


// WEBPACK FOOTER //
// ./src/actions/files.js